import { Component } from "react";
import { Redirect } from "react-router-dom";
import NewPasswordModal from '../components/NewPasswordModal';

export default class Header extends Component {

  constructor(props) {
    super(props)
    this.state = {
      completed: false,
      showModal: false
    }
  }

  onLogout = (event) => {
    event.preventDefault()
    localStorage.removeItem('token');
    localStorage.removeItem('token')
    this.setState({ completed: true })
  }

  newPassword = (event) => {
    event.preventDefault()
    this.setState({ showModal: true })
  }

  render() {
    let closeModal = () => this.setState({ showModal: false })
    return (
      <nav className="main-header navbar navbar-expand navbar-white navbar-light">
        {this.state.completed ? <Redirect to="/" /> : null}
        {this.state.showModal ? <NewPasswordModal show={true} onHide={closeModal} /> : null}
        {/* Left navbar links */}
        <ul className="navbar-nav">
          <li className="nav-item">
            <a
              className="nav-link d-block d-md-none"
              href="/"
              onClick={(e) => e.preventDefault()}
              data-widget="pushmenu"
              role="button"
            >
              <i className="fas fa-bars" />
            </a>
          </li>
        </ul>

        {/* Right navbar links */}
        <ul className="navbar-nav ml-auto">
          {/* Notifications Dropdown Menu */}
          <li className="nav-item dropdown">
            <a className="nav-link" data-toggle="dropdown" href="#">
              <i className="fas fa-user" />
              <span className="pl-1">{JSON.parse(localStorage.getItem('user')).fullname}</span>
            </a>
            <div className="dropdown-menu dropdown-menu-lg dropdown-menu-right">
              <div className="dropdown-divider" />
              <a onClick={this.newPassword} href="#" className="dropdown-item dropdown-action">
                <i className="fas fa-key mr-2 text-primary" /> Change Password
              </a>
              <div className="dropdown-divider" />
              <a onClick={this.onLogout} href="#" className="dropdown-item dropdown-action">
                <i className="fas fa-sign-out-alt mr-2 text-danger" /> Log out
              </a>
            </div>
          </li>
        </ul>
      </nav>
    );
  }
}
